// extracted by mini-css-extract-plugin
module.exports =  {"inline-crumblepath":"InlineCrumblepath-THSx__inline-crumblepath"};